
const headerEl = document.querySelector('header');
const headerH = $(headerEl) ? $(headerEl).height() : 0;

// Add class
// ----------------------------------------------
function addClass(element, className) {
    if (! $(element).length) {
        return false;
    }
    if (element.classList) {
        element.classList.add(className);
    }
    else {
        element.className += ' ' + className;
    }
}

// Remove class
// ----------------------------------------------
function removeClass(element, className) {
    if (! $(element).length) {
        return false;
    }
    if (element.classList) {
        element.classList.remove(className);
    }
    else {
        element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
}

// Check if element has class
// ----------------------------------------------
function hasClass(element, className) {
    if (! $(element).length) {
        return false;
    }
    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
}

// Toggle class
// ----------------------------------------------
function toggleClass(element, className) {
    if (! $(element).length) {
        return false;
    }
    if (element.classList) {
        element.classList.toggle(className);
    } else {
        let classes = element.className.split(' ');
        let existingIndex = classes.indexOf(className);

        if (existingIndex >= 0)
            classes.splice(existingIndex, 1);
        else
            classes.push(className);

        element.className = classes.join(' ');
    }
}

// Higlighting nav items on scroll
// ----------------------------------------------
document.addEventListener('DOMContentLoaded', function () {
    let anchors = document.querySelectorAll('.anchorMenu ul a');
    if (! $(anchors).length) {
        return false;
    }
    let anchorsArray = [];

    // Push anchor's hrefs into the array
    for (let i = 0; i < anchors.length; i++) {
        let anchor = anchors[i],
            ahref = anchor.getAttribute('href');
        anchorsArray.push(ahref);
    }

    // Functions to call when user scrolls
    window.onscroll = function () {

        let scrollPosition = window.pageYOffset,
            windowHeight = window.innerHeight,
            docHeight = document.documentElement.offsetHeight,
            headerOffset = headerH * 2;

        for (let i = 0; i < anchorsArray.length; i++) {
            // Loop over anchor's href tags and set classes
            let theID = anchorsArray[i],
                divTop = document.querySelector(theID).offsetTop - headerOffset,
                divHeight = document.querySelector(theID).offsetHeight;

            if (scrollPosition >= divTop && scrollPosition < (divTop + divHeight)) {
                addClass(document.querySelector('.anchorMenu ul a[href="' + theID + '"]'), 'active');
            } else {
                removeClass(document.querySelector('.anchorMenu ul a[href="' + theID + '"]'), 'active');
            }
        }
    }

}, false);